import { CommonModule } from '@angular/common'
import { Component, inject, input, output } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { SignupInput } from '@mattrika/benefit-model'
import { NgIconComponent, provideIcons } from '@ng-icons/core'
import { lucideArrowRight } from '@ng-icons/lucide'
import { RegisterFormService } from '../../services/register-form.service'
import { UserInfoFormComponent } from '../user-info-form/user-info-form.component'

@Component({
    selector: 'lib-register-user-form',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        NgIconComponent,
        UserInfoFormComponent,
    ],
    templateUrl: './register-user-form.component.html',
    providers: [
        RegisterFormService,
        provideIcons({
            lucideArrowRight,
        }),
    ],
})
export class RegisterUserFormComponent {
    public readonly registerFormService = inject(RegisterFormService)

    public readonly formSubmit = output<SignupInput>()
    public readonly disabled = input<boolean>(false)

    onSubmit() {
        if (this.registerFormService.form.valid) {
            this.formSubmit.emit(
                this.registerFormService.getValue() as SignupInput,
            )
        } else {
            this.registerFormService.form.markAllAsTouched()
        }
    }
}
